import { Row, Col } from 'src/componentes/grid';

import { capitalizeFirstLetter } from 'src/utils/string';
import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import CheckBox from 'src/componentes/checkbox';
import PerfilLookup from 'src/lookups/perfil';
import StatusColaboradorLookup from 'src/lookups/status-colaborador';
import CondicionalLookup from 'src/lookups/condicional';
import ModuloLookup from 'src/lookups/ModuloLookup';
import IdiomaLookup from 'src/lookups/idioma';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import CollapsibleSection from 'src/componentes/CollapsibleSection';

import { hasSearchMatch } from './searchUtils';

const ResumoSection = ({ model, resources, intl, searchQuery }) => {
  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);

  const sectionTerms = [
    intl.formatMessage({ id: 'label.resumo' }),
    intl.formatMessage({ id: 'nome' }),
    intl.formatMessage({ id: 'matricula' }),
    resources?.area,
    intl.formatMessage(
      { id: 'label.considerarAreasSubordinadas' },
      { areas: resources?.areas }
    ),
    intl.formatMessage({ id: 'status' }),
    intl.formatMessage({ id: 'perfis' }),
    intl.formatMessage({ id: 'email' }),
    intl.formatMessage({ id: 'emailBoasVindasEnviado' }),
    intl.formatMessage({ id: 'usuario' }),
    intl.formatMessage({ id: 'label.bloquearUsuario' }),
    intl.formatMessage({ id: 'modulos' }),
    intl.formatMessage({ id: 'label.idioma' }),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'label.resumo' })} startOpen>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'nome' })]) && (
          <Col md={12}>
            <Input model={model.getModel('nome')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'matricula' })]) && (
          <Col md={12}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
        )}
        {fieldMatches([resources?.area]) && (
          <Col md={12}>
            <ItemOrganizacaoLookup
              model={{
                label: capitalizeFirstLetter(resources.area),
                value: model.getModel('area').value,
                requestChange: model.getModel('area').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              clearable
            />
          </Col>
        )}
        {fieldMatches([
          intl.formatMessage(
            { id: 'label.considerarAreasSubordinadas' },
            { areas: resources?.areas }
          ),
        ]) && (
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources.areas }
                ),
                value: model.getModel('areasSubordinadas').value,
                requestChange: model.getModel('areasSubordinadas').requestChange,
              }}
              disabled={!model.getModel('area').value}
              className="mb-3"
            />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'status' })]) && (
          <Col md={12}>
            <StatusColaboradorLookup model={model.getModel('status')} clearable />
          </Col>
        )}
      </Row>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'perfis' })]) && (
          <Col md={12}>
            <PerfilLookup model={model.getModel('perfis')} clearable />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'email' })]) && (
          <Col md={12}>
            <Input model={model.getModel('email')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'emailBoasVindasEnviado' })]) && (
          <Col md={12}>
            <CondicionalLookup clearable model={model.getModel('emailBoasVindasEnviado')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'usuario' })]) && (
          <Col md={12}>
            <Input model={model.getModel('usuario')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'label.bloquearUsuario' })]) && (
          <Col md={12}>
            <CheckBox model={model.getModel('bloqueadoTentativaLogin')} className="mb-3" />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'modulos' })]) && (
          <Col md={12}>
            <ModuloLookup multi model={model.getModel('modulos')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'label.idioma' })]) && (
          <Col md={12}>
            <IdiomaLookup model={model.getModel('idioma')} clearable />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default ResumoSection;
